// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-tagGroup":"jobSearchDetail-tagGroup"};